import { useEffect, useCallback } from 'react';
import {
  roundToDecimals,
  getFormattedMoney,
  getPotentialSaving,
  getPaidDebt,
  getNumberFromInput,
} from '@/components/thanks-page/utils/helpers';
import useThanksPageStore from '@/components/thanks-page/hooks/useThanksPageStore';
import Dialog from '@/components/dialog';
import Quiz from '@/components/quiz';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { SliderSlice } from '@/redux/slider';
import '@/components/thanks-page/thanks-page.css';

const ThanksPage = () => {
  const dispatch = useAppDispatch();
  const answersDirect = useAppSelector(SliderSlice.selectors.answersDirect);
  const config = useAppSelector(ConfigSlice.selectors.config);

  const { state, setState } = useThanksPageStore();

  const getGesamtSchulden = useCallback(() => {
    return getNumberFromInput(answersDirect['gesamtschulden']);
  }, [answersDirect]);

  const calculate = useCallback(() => {
    const calculatedEingabeB6 = getGesamtSchulden();

    const eingabeB5 = () => {
      if (answersDirect['kinder'] && (answersDirect['kinder'] === 'Nein' || answersDirect['kinder'] === 'Sonstiges')) {
        return 0;
      }
      return getNumberFromInput(answersDirect['kinderanzahl']);
    };

    const eingabeB1 = () => {
      return getNumberFromInput(answersDirect['einkommen']);
    };

    const eingabeB2 = () => {
      return getNumberFromInput(answersDirect['einkommen-ehegatte']);
    };

    const eingabeB3 = () => {
      return answersDirect['familienstand'] ? answersDirect['familienstand'] : 'Ledig';
    };

    const eingabeB4 = () => {
      return answersDirect['veranschlagung'] && answersDirect['veranschlagung'] === 'Gemeinsam'
        ? 'Gemeinsam'
        : 'Einzeln';
    };

    const berechnungB2 = () => {
      return Math.min(eingabeB1() * 0.1, 486);
    };

    const berechnungB3 = () => {
      return Math.min(eingabeB2() * 0.1, 486);
    };

    const stepsB4 = () => 0;
    const stepsC4 = () => 60;
    const stepsD4 = () => 93;
    const stepsE4 = () => 127;
    const stepsF4 = () => 160;
    const stepsG4 = () => 193;

    const stepsB2 = () => 7;
    const stepsC2 = () => 5;
    const stepsD2 = () => 4;
    const stepsE2 = () => 3;
    const stepsF2 = () => 2;
    const stepsG2 = () => 1;

    const stepsB3 = () => 1.82;
    const stepsC3 = () => 2.59;
    const stepsD3 = () => 0.94;
    const stepsE3 = () => 2.86;
    const stepsF3 = () => 1.34;
    const stepsG3 = () => 0.39;

    const berechnungB8 = () => {
      if (
        (eingabeB3() === 'Verheiratet' || eingabeB3() === 'Lebenspartnerschaft') &&
        eingabeB4() !== 'Gemeinsam' &&
        eingabeB2() <= 700
      ) {
        return 1;
      }
      if (eingabeB4() === 'Gemeinsam' && (eingabeB2() <= 700 || eingabeB1() <= 700)) {
        return 1;
      }
      return 0;
    };

    const berechnungB9 = () => {
      return Math.min(berechnungB8() + eingabeB5(), 5);
    };

    const berechnungD12 = () => (berechnungB9() === 1 ? stepsC4() : 0);
    const berechnungE12 = () => (berechnungB9() === 2 ? stepsD4() : 0);
    const berechnungF12 = () => (berechnungB9() === 3 ? stepsE4() : 0);
    const berechnungG12 = () => (berechnungB9() === 4 ? stepsF4() : 0);
    const berechnungH12 = () => (berechnungB9() === 5 ? stepsG4() : 0);
    const berechnungC12 = () => (berechnungB9() === 0 ? stepsB4() : 0);

    const berechnungB12 = () => {
      return berechnungC12() + berechnungD12() + berechnungE12() + berechnungF12() + berechnungG12() + berechnungH12();
    };

    const berechnungB14 = () => {
      return berechnungB2() - (berechnungB12() + 159);
    };

    const berechnungC10 = () => (berechnungB9() === 0 ? stepsB2() : 0);
    const berechnungD10 = () => (berechnungB9() === 1 ? stepsC2() : 0);
    const berechnungE10 = () => (berechnungB9() === 2 ? stepsD2() : 0);
    const berechnungF10 = () => (berechnungB9() === 3 ? stepsE2() : 0);
    const berechnungG10 = () => (berechnungB9() === 4 ? stepsF2() : 0);
    const berechnungH10 = () => (berechnungB9() === 5 ? stepsG2() : 0);

    const berechnungB10 = () => {
      return berechnungC10() + berechnungD10() + berechnungE10() + berechnungF10() + berechnungG10() + berechnungH10();
    };

    const berechnungB5 = () => {
      const result = eingabeB1() - 4859.99;
      return result < 0 ? 0 : result;
    };

    const berechnungC11 = () => (berechnungB9() === 0 ? stepsB3() : 0);
    const berechnungD11 = () => (berechnungB9() === 1 ? stepsC3() : 0);
    const berechnungE11 = () => (berechnungB9() === 2 ? stepsD3() : 0);
    const berechnungF11 = () => (berechnungB9() === 3 ? stepsE3() : 0);
    const berechnungG11 = () => (berechnungB9() === 4 ? stepsF3() : 0);
    const berechnungH11 = () => (berechnungB9() === 5 ? stepsG3() : 0);

    const berechnungB11 = () => {
      return berechnungC11() + berechnungD11() + berechnungE11() + berechnungF11() + berechnungG11() + berechnungH11();
    };

    const berechnungB6 = () => {
      const result = eingabeB2() - 4859.99;
      return result < 0 ? 0 : result;
    };

    const berechnungB15 = () => {
      return berechnungB3() - (berechnungB12() + 159);
    };

    const berechnungB18 = () => {
      let rv1 = 0;
      if (berechnungB3() >= 159 + berechnungB12()) {
        rv1 = berechnungB15() * berechnungB10() + berechnungB6() + berechnungB11();
      }
      return Math.max(rv1, 0);
    };

    const berechnungB17 = () => {
      let rv = 0;
      if (eingabeB1() >= 159 + berechnungB12()) {
        rv = berechnungB14() * berechnungB10() + berechnungB5() + berechnungB11();
      }
      return Math.max(rv, 0);
    };

    const berechnungB20 = () => {
      if (eingabeB4() === 'Einzeln') {
        return berechnungB17();
      }
      return berechnungB17() + berechnungB18();
    };

    const eingabeB8 = () => berechnungB20();
    const eingabeB9 = () => 50;
    const eingabeB15 = () => 36;
    const eingabeB6 = () => calculatedEingabeB6;

    const eingabeB11 = () => {
      const val = (eingabeB10() - eingabeB9()) * eingabeB15();
      if (val <= eingabeB6()) {
        return val;
      }
      return eingabeB6();
    };

    const eingabeB10 = () => {
      const val = eingabeB6() * (0.3 / 36) + eingabeB9();
      if (val >= eingabeB8()) {
        return val;
      }
      return eingabeB8();
    };

    const eingabeB7 = () => {
      if (eingabeB11() === eingabeB6()) {
        return eingabeB10() > 0 ? eingabeB11() / eingabeB10() : 0;
      }
      return 36;
    };

    const eingabeC10 = () => {
      if (eingabeB10() > eingabeB6()) {
        return eingabeB6() + eingabeB9();
      }
      return eingabeB10();
    };

    const eingabeD10 = () => {
      return eingabeC10() > 0;
    };

    return {
      isCalculationValid: eingabeD10(),
      term: eingabeB7(),
      monthlyRate: eingabeC10(),
      garnishmentAmount: eingabeB8(),
      eingabeB6: calculatedEingabeB6,
    };
  }, [answersDirect, getGesamtSchulden]);

  useEffect(() => {
    const calculation = calculate();

    if (config && config.calculationPageUrlName) {
      window.history.pushState('', '', config.calculationPageUrlName);
    }

    const timer = setTimeout(() => {
      setState({
        type: 'SET_CALCULATION_RESULT',
        payload: {
          monthlyRate: calculation.monthlyRate,
          term: calculation.term,
          isCalculationValid: calculation.isCalculationValid,
          eingabeB6: calculation.eingabeB6,
        },
      });

      dispatch(
        GeneralSlice.actions.setDebtAnalysis({
          rate: getFormattedMoney(roundToDecimals(calculation.monthlyRate)),
          months: Math.ceil(calculation.term).toString(),
        }),
      );

      if (calculation.isCalculationValid) {
        setState({ type: 'SHOW_QUIZ' });
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [calculate, config]);

  const { showPage, isCalculationValid, monthRate, runningTime, eingabeB6 } = state;

  if (!showPage) {
    return (
      <div className='loading-container' style={{ textAlign: 'center' }}>
        <div className='circle-loader' />
      </div>
    );
  }

  const calculatedMonthRate = roundToDecimals(monthRate);
  const potentialSaving = getPotentialSaving(eingabeB6, calculatedMonthRate, runningTime);
  const paidDebt = getPaidDebt(calculatedMonthRate, runningTime);
  const runningTimeCeil = Math.ceil(runningTime);

  return (
    <div className='thanks-container'>
      <h1 className='tp-h1'>Vielen Dank für Ihre Anfrage.</h1>
      <div className='tp-page-container'>
        <div className='tp-head'>
          <h3 className='tp-h3'>Herzlichen Glückwunsch!</h3>
          {isCalculationValid ? (
            <h4 className='tp-h4'>Eine Entschuldung ohne Insolvenz könnte möglich sein</h4>
          ) : (
            <h4 className='tp-h4'>Sie haben den ersten Schritt in eine schuldenfreie Zukunft gemacht</h4>
          )}
        </div>
        {isCalculationValid && (
          <div className='tp-paragraph'>
            Eine erste Analyse Ihrer Angaben ergibt folgende Möglichkeit für eine Schuldenregulierung:
          </div>
        )}
        {isCalculationValid && (
          <div className='tp-berechnung'>
            <ul className='tp-list'>
              <li>
                <strong>Monatliche Rate:</strong> {getFormattedMoney(calculatedMonthRate)} Euro *
              </li>
              <li>
                <strong>Schuldenfrei in:</strong> {runningTimeCeil} Monaten
              </li>
              <li>
                <strong>Ziel:</strong> Vermeidung der Insolvenz
              </li>
              {potentialSaving > 0 && (
                <div style={{ borderTop: '1px solid #e3e3e3', marginTop: '10px', paddingTop: '10px' }}>
                  <li>
                    <strong>Ergebnis:</strong> Statt {getFormattedMoney(eingabeB6)} Euro zahlen Sie nur{' '}
                    {getFormattedMoney(paidDebt)} Euro zurück
                  </li>
                  <li>
                    <strong>Mögliche Ersparnis:</strong>{' '}
                    <span style={{ textDecoration: 'underline' }}>{getFormattedMoney(potentialSaving)} Euro</span> *
                  </li>
                </div>
              )}
            </ul>
          </div>
        )}
        {isCalculationValid ? (
          <div className='tp-paragraph'>
            Sofern eine Ratenzahlung für Sie nicht möglich ist, informieren wir Sie auch gerne kostenlos über die
            Möglichkeit eines Privatinsolvenzverfahrens.
            <br />
            <br />
            Im Rahmen eines <strong>kostenlosen und unverbindlichen</strong> Telefonats wird Ihnen unser geschultes Team
            das Ergebnis des Schuldenchecks erläutern und offene Fragen mit Ihnen klären.
          </div>
        ) : (
          <div className='tp-paragraph'>
            Um Ihren Fall besser bewerten zu können, benötigen wir noch weitere Informationen.
            <br />
            <br />
            Im Rahmen eines <strong>kostenlosen und unverbindlichen</strong> Telefonats wird Ihnen unser geschultes Team
            das Ergebnis des Schuldenchecks erläutern und offene Fragen mit Ihnen klären.
          </div>
        )}
      </div>
      {isCalculationValid && (
        <div className='tp-footer'>
          <div className='tp-footer-star-wrapper'>
            <div className='tp-footer-star'>*</div>
            <div className='tp-footer-content'>
              Dies ist kein verbindliches Angebot. Die genaue Höhe der monatlichen Rate hängt von weiteren Faktoren ab.
              Die Berechnung findet im Rahmen unseres kostenlosen und unverbindlichen Erstgesprächs statt.
            </div>
          </div>
        </div>
      )}
      <Dialog
        on={state.isQuizShown}
        size='2/3'
        position='center'
        heightMax='70'
        onClose={() => setState({ type: 'HIDE_QUIZ' })}
      >
        <Quiz onCompleteQuiz={() => setState({ type: 'HIDE_QUIZ' })} />
      </Dialog>
    </div>
  );
};

export default ThanksPage;
